import { render } from "./humanityCourse.vue?vue&type=template&id=a2865a9c&scoped=true"
import script from "./humanityCourse.vue?vue&type=script&lang=js"
export * from "./humanityCourse.vue?vue&type=script&lang=js"

import "./humanityCourse.vue?vue&type=style&index=0&id=a2865a9c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2865a9c"]])

export default __exports__